import React from "react";
import { MessageCirclePlus } from "lucide-react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { setIsNewChatClicked } from "../../../../store/features/ui/uiSlice";
import {
  setIsGrievanceStatusFlowEnded,
  setIsNotRelatedToCenter,
} from "../../../../store/features/message/textContentSlice";
import useLocalization from "../../../../hooks/useLocalization";
import { useAppContext } from "../../../../context/AppContext";
import { resetAppChatState } from "../../../../utils/appReset/resetAppChatState";

/**
 * Rendered when the backend marks the grievance status flow as finished
 * (isGrievanceStatusFlowEnded). No follow-up is allowed on this flow, so the
 * only available action is starting a new chat.
 */
function GrievanceStatusFlowEnd({ isFlowEnded }) {
  const { t } = useLocalization();
  const { sharedApiService, setIsNewChat, setSelectedLanguageData } =
    useAppContext();
  const dispatch = useDispatch();

  const handleNewChat = () => {
    resetAppChatState({
      dispatch,
      sharedApiService,
      setSelectedLanguageData,
    });

    dispatch(setIsNotRelatedToCenter(false));
    dispatch(setIsGrievanceStatusFlowEnded(false));

    setIsNewChat(true);
    dispatch(setIsNewChatClicked(true));
  };

  if (!isFlowEnded) return null;

  return (
    <div className="w-full mt-6 px-4 animate-fadeIn">
      <div className="max-w-3xl mx-auto">
        <button
          onClick={handleNewChat}
          className="w-full px-6 py-4 rounded-2xl font-semibold border-2 border-purple-200 text-purple-600 hover:bg-purple-50 hover:border-purple-300 transition-all duration-300 hover:shadow-md transform hover:scale-105 active:scale-95 flex items-center justify-center gap-2"
        >
          <MessageCirclePlus className="w-5 h-5" />
          <span>
            {t("lodgeFreshGrievance") || "Click here to lodge fresh grievance"}
          </span>
        </button>
      </div>
    </div>
  );
}

GrievanceStatusFlowEnd.propTypes = {
  isFlowEnded: PropTypes.bool,
};

export default GrievanceStatusFlowEnd;
